const interval = {
    itemList: 60,
    chat: 20,
    messages:19,
    counter:30,
    timeline:300
};
export default interval;